import React from 'react';
import { EmployeeStatsProvider } from './hooks/useEmployeeStats';
import EmployeeReport from './EmployeeReport';

const EmployeeReportContainer = () => {
  return (
    <EmployeeStatsProvider>
      <EmployeeReport />
    </EmployeeStatsProvider>
  );
};

export default EmployeeReportContainer;
